/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Record Service API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CollectionQueryRequest,
  CollectionQueryResponse,
  ParentScopedReachableChildrenQueryRequest,
} from "../model";

import { customFetch } from "../../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type queryChildrenUnderParentResponse200 = {
  data: CollectionQueryResponse;
  status: 200;
};

export type queryChildrenUnderParentResponse400 = {
  data: void;
  status: 400;
};

export type queryChildrenUnderParentResponse403 = {
  data: void;
  status: 403;
};

export type queryChildrenUnderParentResponse404 = {
  data: void;
  status: 404;
};

export type queryChildrenUnderParentResponseSuccess = queryChildrenUnderParentResponse200 & {
  headers: Headers;
};
export type queryChildrenUnderParentResponseError = (
  | queryChildrenUnderParentResponse400
  | queryChildrenUnderParentResponse403
  | queryChildrenUnderParentResponse404
) & {
  headers: Headers;
};

export type queryChildrenUnderParentResponse =
  | queryChildrenUnderParentResponseSuccess
  | queryChildrenUnderParentResponseError;

export const getQueryChildrenUnderParentUrl = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
) => {
  return `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}/query`;
};

/**
 * The parent is the path. The body is a CollectionQueryRequest and may only narrow the
 * relationship-store child set. Do not send a parent property. The relationship name and
 * version are the target schema name and version.
 * @summary Query children linked to one parent through a named relationship
 */
export const queryChildrenUnderParent = async (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<queryChildrenUnderParentResponse> => {
  return customFetch<queryChildrenUnderParentResponse>(
    getQueryChildrenUnderParentUrl(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
    ),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(collectionQueryRequest),
    },
  );
};

export const getQueryChildrenUnderParentQueryKey = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
) => {
  return [
    "POST",
    `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/relationships/${relationshipName}/${relationshipVersion}/children/${childResource}/${childVersion}/query`,
    collectionQueryRequest,
  ] as const;
};

export const getQueryChildrenUnderParentQueryOptions = <
  TData = Awaited<ReturnType<typeof queryChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryChildrenUnderParentQueryKey(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      collectionQueryRequest,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queryChildrenUnderParent>>> = ({
    signal,
  }) =>
    queryChildrenUnderParent(
      parentResource,
      parentVersion,
      parentPk,
      relationshipName,
      relationshipVersion,
      childResource,
      childVersion,
      collectionQueryRequest,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      parentResource !== null &&
      parentResource !== undefined &&
      parentVersion !== null &&
      parentVersion !== undefined &&
      parentPk !== null &&
      parentPk !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined &&
      childResource !== null &&
      childResource !== undefined &&
      childVersion !== null &&
      childVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type QueryChildrenUnderParentQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryChildrenUnderParent>>
>;
export type QueryChildrenUnderParentQueryError = void;

export function useQueryChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest: undefined | CollectionQueryRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryChildrenUnderParent>>,
          TError,
          Awaited<ReturnType<typeof queryChildrenUnderParent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryChildrenUnderParent>>,
          TError,
          Awaited<ReturnType<typeof queryChildrenUnderParent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Query children linked to one parent through a named relationship
 */

export function useQueryChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  relationshipName: string,
  relationshipVersion: string,
  childResource: string,
  childVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQueryChildrenUnderParentQueryOptions(
    parentResource,
    parentVersion,
    parentPk,
    relationshipName,
    relationshipVersion,
    childResource,
    childVersion,
    collectionQueryRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type queryReachableChildrenUnderParentResponse200 = {
  data: CollectionQueryResponse;
  status: 200;
};

export type queryReachableChildrenUnderParentResponse400 = {
  data: void;
  status: 400;
};

export type queryReachableChildrenUnderParentResponse403 = {
  data: void;
  status: 403;
};

export type queryReachableChildrenUnderParentResponse404 = {
  data: void;
  status: 404;
};

export type queryReachableChildrenUnderParentResponseSuccess =
  queryReachableChildrenUnderParentResponse200 & {
    headers: Headers;
  };
export type queryReachableChildrenUnderParentResponseError = (
  | queryReachableChildrenUnderParentResponse400
  | queryReachableChildrenUnderParentResponse403
  | queryReachableChildrenUnderParentResponse404
) & {
  headers: Headers;
};

export type queryReachableChildrenUnderParentResponse =
  | queryReachableChildrenUnderParentResponseSuccess
  | queryReachableChildrenUnderParentResponseError;

export const getQueryReachableChildrenUnderParentUrl = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
) => {
  return `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/related/${childResource}/${childVersion}/query`;
};

/**
 * The parent is the path. The body is a collection query plus a non-empty `path` array of hop targets
 * (`resource`, `version`, optional `direction`). Each hop must match the next relationship step from the
 * parent type to the child type named in the URL. An `incoming` hop follows a stored edge from its target
 * back to its source (where-used), for example Material ← SRLineItem ← SupplierRequest. The query may only
 * narrow the resolved child id set.
 * @summary Query children reachable from one parent along a typed path
 */
export const queryReachableChildrenUnderParent = async (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<queryReachableChildrenUnderParentResponse> => {
  return customFetch<queryReachableChildrenUnderParentResponse>(
    getQueryReachableChildrenUnderParentUrl(
      parentResource,
      parentVersion,
      parentPk,
      childResource,
      childVersion,
    ),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(parentScopedReachableChildrenQueryRequest),
    },
  );
};

export const getQueryReachableChildrenUnderParentQueryKey = (
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest?: ParentScopedReachableChildrenQueryRequest,
) => {
  return [
    "POST",
    `/record-service/v1/${parentResource}/${parentVersion}/${parentPk}/related/${childResource}/${childVersion}/query`,
    parentScopedReachableChildrenQueryRequest,
  ] as const;
};

export const getQueryReachableChildrenUnderParentQueryOptions = <
  TData = Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryReachableChildrenUnderParentQueryKey(
      parentResource,
      parentVersion,
      parentPk,
      childResource,
      childVersion,
      parentScopedReachableChildrenQueryRequest,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>> = ({
    signal,
  }) =>
    queryReachableChildrenUnderParent(
      parentResource,
      parentVersion,
      parentPk,
      childResource,
      childVersion,
      parentScopedReachableChildrenQueryRequest,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      parentResource !== null &&
      parentResource !== undefined &&
      parentVersion !== null &&
      parentVersion !== undefined &&
      parentPk !== null &&
      parentPk !== undefined &&
      childResource !== null &&
      childResource !== undefined &&
      childVersion !== null &&
      childVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QueryReachableChildrenUnderParentQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>
>;
export type QueryReachableChildrenUnderParentQueryError = void;

export function useQueryReachableChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
          TError,
          Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryReachableChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
          TError,
          Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryReachableChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Query children reachable from one parent along a typed path
 */

export function useQueryReachableChildrenUnderParent<
  TData = Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>,
  TError = void,
>(
  parentResource: string,
  parentVersion: string,
  parentPk: string,
  childResource: string,
  childVersion: string,
  parentScopedReachableChildrenQueryRequest: ParentScopedReachableChildrenQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryReachableChildrenUnderParent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQueryReachableChildrenUnderParentQueryOptions(
    parentResource,
    parentVersion,
    parentPk,
    childResource,
    childVersion,
    parentScopedReachableChildrenQueryRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
